import React from 'react';

// Connector logos: add new imports here for each connector (png or svg).
import googleDriveLogo from '../assets/connectors/google-drive.png';
import googleSearchConsoleLogo from '../assets/connectors/google-search-console.png';

const CONNECTOR_LOGOS: Record<string, string> = {
  google_drive: googleDriveLogo,
  google_search_console: googleSearchConsoleLogo,
};

export interface ConnectorLogoProps {
  connectorType: string;
  className?: string;
  size?: number;
  alt?: string;
}

/**
 * Renders the logo for a data source connector type (e.g. Google Drive).
 * Returns null if no logo is configured for the type (caller can show a fallback icon).
 */
const ConnectorLogo: React.FC<ConnectorLogoProps> = ({
  connectorType,
  className = '',
  size = 24,
  alt = 'Connector',
}) => {
  const src = connectorType ? CONNECTOR_LOGOS[connectorType] : null;
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ width: size, height: size }}
      loading="lazy"
    />
  );
};

export default ConnectorLogo;

/**
 * Returns the logo URL for a connector type, or null if not configured.
 * Use when you need the URL without rendering (e.g. for background or custom elements).
 */
export function getConnectorLogoUrl(connectorType: string): string | null {
  return connectorType ? CONNECTOR_LOGOS[connectorType] ?? null : null;
}

/**
 * Returns true if we have a logo for this connector type.
 */
export function hasConnectorLogo(connectorType: string): boolean {
  return Boolean(connectorType && CONNECTOR_LOGOS[connectorType]);
}
